module.exports = __webpack_public_path__ + "static/media/About.3da7e98f.svg";